import { ApiService } from '../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { ProjectDto } from './dto/project.dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private _apiService: ApiService) {}

  createProject(project: ProjectDto): Promise<number> {
    return this._apiService.post('Projects', project);
  }
}
